export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  category: string;
  sub_category: string;
  benefits: string[];
  thumbnail: string;
}

export const SubCategory: string[] = [
  "Heart Health",
  "Joints & Bones Health",
  "Immunity Booster",
  "Fitness & Weight Management",
  "Healthy Essentials",
  "Women's Health & Hygiene",
  "Glycemic Health",
  "Detox & Rejuvenation",
  "Speciality Supplements",
  "Daily Essentials",
  "Kid's Essentials",
];
